import React from 'react'
import AldooSlotRenderer from './AldooSlotRenderer'

/**
 * AldooLayoutRenderer
 * Renders a layout with all its slots in a CSS Grid with 12 columns
 *
 * @param {Object} layout - The layout data from CMS
 * @param {string} layout.id - Layout identifier
 * @param {Array} layout.slots - Array of slot references
 * @param {Object} pageData - Page data to pass down to slots
 */
const AldooLayoutRenderer = ({ layout, pageData }) => {
  if (!layout) {
    console.warn('AldooLayoutRenderer: No layout data provided')
    return null
  }

  const slots = layout.slots || []

  if (slots.length === 0) {
    console.warn(`AldooLayoutRenderer: Layout "${layout.id}" has no slots`)
    return null
  }

  // Sort slots by position (row first, then column) for proper rendering order
  const sortedSlots = [...slots].sort((a, b) => {
    const slotA = a.content || a
    const slotB = b.content || b

    // Handle position being an array (corrupted data)
    let posA = slotA.position || { row: 0, col: 0 }
    if (Array.isArray(posA)) {
      posA = posA.reduce((acc, item) => {
        if (item.key) acc[item.key] = parseInt(item.value) || 0
        return acc
      }, { row: 0, col: 0 })
    }

    let posB = slotB.position || { row: 0, col: 0 }
    if (Array.isArray(posB)) {
      posB = posB.reduce((acc, item) => {
        if (item.key) acc[item.key] = parseInt(item.value) || 0
        return acc
      }, { row: 0, col: 0 })
    }

    // Sort by row first
    if (posA.row !== posB.row) {
      return posA.row - posB.row
    }
    // Then by column
    return posA.col - posB.col
  })

  return (
    <div
      className="aldoo-layout grid"
      data-layout-id={layout.id}
      style={{
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridAutoRows: 'auto', // Let content determine height
        width: '100%',
      }}
    >
      {sortedSlots.map((slotRef, index) => {
        // slotRef should have the populated content from the CMS
        const slot = slotRef.content || slotRef

        if (!slot || !slot.id) {
          console.warn(`AldooLayoutRenderer: Invalid slot at index ${index} in layout "${layout.id}"`, slotRef)
          return null
        }

        return (
          <AldooSlotRenderer
            key={slot._id || slot.id || index}
            slot={slot}
            pageData={pageData}
            layoutData={{
              id: layout.id,
              _id: layout._id,
            }}
          />
        )
      })}
    </div>
  )
}

export default AldooLayoutRenderer